export default __webpack_public_path__ + "locales/sk/Settings.json?hash=c492212e17b653eb55677f438eaf78d1";